import i18next from "i18next";
import landingPage_ar from "./ar/landingPage.json";
import login_fr from "./fr/login.json";
import login_ar from "./ar/login.json";
import contacter_fr from "./fr/contacter.json";
import contacter_ar from "./ar/contacter.json";
import landingPage_fr from "./fr/landingPage.json";
import rejoindre_ar from "./ar/rejoindre.json";
import rejoindre_fr from "./fr/rejoindre.json";
import financement_ar from "./ar/financement.json";
import financement_fr from "./fr/financement.json";
import demande_ar from "./ar/demande.json";
import demande_fr from "./fr/demande.json";
import compte_ar from "./ar/compte.json";
import compte_fr from "./fr/compte.json";
import securite_fr from "./fr/securite.json";
import securite_ar from "./ar/securite.json";
import inscription_fr from "./fr/inscriptionAlreadyClient.json";
import inscription_ar from "./ar/inscriptionAlreadyClient.json";
import noteBam_fr from "./fr/noteBam.json";
import noteBam_ar from "./ar/noteBam.json";
import pedagogieConseil_fr from "./fr/PedagogieConseil.json";
import pedagogieConseil_ar from "./ar/PedagogieConseil.json";

i18next.init({
    interpolation: { escapeValue: false }, // React already does escaping
    lng: localStorage.getItem("i18nextLng") || "fr", // language to use
    resources: {
        ar: {
            landingPage: landingPage_ar,
            login: login_ar,
            contacter: contacter_ar,
            rejoindre: rejoindre_ar,
            demande: demande_ar,
            financement: financement_ar,
            compte: compte_ar,
            securite: securite_ar,
            inscriptionAlredyClient: inscription_ar,
            noteBam: noteBam_ar,
            pedagogieConseil: pedagogieConseil_ar
        },
        fr: {
            landingPage: landingPage_fr,
            login: login_fr,
            contacter: contacter_fr,
            rejoindre: rejoindre_fr,
            financement: financement_fr,
            demande: demande_fr,
            compte: compte_fr,
            securite: securite_fr,
            inscriptionAlredyClient: inscription_fr,
            noteBam: noteBam_fr,
            pedagogieConseil: pedagogieConseil_fr
        }
    }
});

export default i18next;
